var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 9,
    width: 7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5, 4.5) rotate(180) translate(-3.5, -4.5)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M-0.5 1L7.5 1C7.775957512247 1 8 1.224042487753 8 1.5L8 1.5C8 1.775957512247 7.775957512247 2 7.5 2L-0.5 2C-0.7759575122469999 2 -1 1.775957512247 -1 1.5L-1 1.5C-1 1.224042487753 -0.7759575122470002 1 -0.5000000000000001 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M-0.5 4L7.5 4C7.775957512247 4 8 4.224042487753 8 4.5L8 4.5C8 4.775957512247 7.775957512247 5 7.5 5L-0.5 5C-0.7759575122469999 5 -1 4.775957512247 -1 4.5L-1 4.5C-1 4.224042487753 -0.7759575122470002 4 -0.5000000000000001 4Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M-0.5 7L7.5 7C7.775957512247 7 8 7.224042487753 8 7.5L8 7.5C8 7.775957512247 7.775957512247 8 7.5 8L-0.5 8C-0.7759575122469999 8 -1 7.775957512247 -1 7.5L-1 7.5C-1 7.224042487753 -0.7759575122470002 7 -0.5000000000000001 7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeScroll);
export default __webpack_public_path__ + "static/media/icone-scroll.acdf272198b4dd39fa862b8ae315d575.svg";
export { ForwardRef as ReactComponent };